import type { PullRequestVisual } from '../util';

import {
  ChatCircleIcon,
  CheckIcon,
  GitMergeIcon,
  GitPullRequestIcon,
  XIcon,
} from '@phosphor-icons/react';

const ICONS = {
  check: CheckIcon,
  comment: ChatCircleIcon,
  merge: GitMergeIcon,
  pullRequest: GitPullRequestIcon,
  x: XIcon,
};

type Props = {
  visual: PullRequestVisual;
  size?: number;
};

export default function PullRequestStateIcon({ visual, size = 24 }: Props) {
  const Icon = ICONS[visual.icon];
  return <Icon size={size} color={visual.color} aria-label={visual.label} />;
}
